import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Megaphone, Vote as VoteIcon } from 'lucide-react';
import Card from '../components/common/Card';
import Button from '../components/common/Button';
import PageHero from '../components/common/PageHero';

const Vote = () => {
  return (
    <div className="bg-ink-50">
      <PageHero
        icon={VoteIcon}
        title="Alumni Voting"
        subtitle="Cast your vote for alumni leadership positions"
      />

      {/* Coming Soon Content */}
      <div className="container-page py-12">
        <div className="mx-auto max-w-2xl">
          <Card className="p-8 text-center sm:p-12">
            <div className="mb-6">
              <div className="mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-brand-50">
                <VoteIcon className="h-12 w-12 text-brand-700" aria-hidden="true" />
              </div>
            </div>
            
            <h2 className="mb-3 text-2xl font-bold text-ink-900 sm:text-3xl">
              Voting Coming Soon!
            </h2>
            
            <p className="mb-6 text-ink-500">
              The voting process for alumni leadership positions will begin soon. 
              Please check back later for updates.
            </p>
            
            <div className="mb-6 rounded-xl border border-gold-200 bg-gold-50 p-4 text-left">
              <p className="text-sm text-gold-900">
                <strong className="inline-flex items-center gap-1.5">
                  <Megaphone className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
                  Important Information:
                </strong><br />
                • Only registered alumni can vote<br />
                • Each alumni can vote once per position<br />
                • Voting will be open for 14 days<br />
                • Results will be announced after voting closes
              </p>
            </div>
            
            <div className="flex flex-col justify-center gap-3 sm:flex-row">
              <Link to="/">
                <Button variant="outline" className="w-full gap-2 sm:w-auto">
                  <ArrowLeft className="h-4 w-4" aria-hidden="true" />
                  Back to Home
                </Button>
              </Link>
              <Link to="/alumni/register">
                <Button variant="outline" className="w-full sm:w-auto">
                  Register as Alumnus
                </Button>
              </Link>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Vote;
